/* eslint-disable */
import React from 'react';

/**
 * Icons
 * @param {any} props The props
 * @returns {React.Component} The component
 */

type Props = {
  type: string;
  color?: string;
  size?: string;
  className?: string;
};

const Icons = (props: Props) => {
  // when updating to react-scripts2.0 then use import for custom icons rather then directly embedding svg here
  switch (props.type) {
    case `EMOJI_OBJECTS`:
      return (
        <div {...props}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            enableBackground="new 0 0 24 24"
            viewBox="0 0 24 24"
            fill={props.color || `black`}
            width={props.size ? `${props.size}px` : `18px`}
            height={props.size ? `${props.size}px` : `18px`}
          >
            <g>
              <rect fill="none" height="24" width="24" />
            </g>
            <g>
              <g />
              <path d="M12,3c-0.46,0-0.93,0.04-1.4,0.14C7.84,3.67,5.64,5.9,5.12,8.66c-0.48,2.61,0.48,5.01,2.22,6.56C7.77,15.6,8,16.13,8,16.69 V19c0,1.1,0.9,2,2,2h0.28c0.35,0.6,0.98,1,1.72,1s1.38-0.4,1.72-1H14c1.1,0,2-0.9,2-2v-2.31c0-0.55,0.22-1.09,0.64-1.46 C18.09,13.95,19,12.08,19,10C19,6.13,15.87,3,12,3z M14,19h-4v-1h4V19z M14,17h-4v-1h4V17z M12.5,11.41V14h-1v-2.59L9.67,9.59 l0.71-0.71L12,10.5l1.62-1.62l0.71,0.71L12.5,11.41z" />
            </g>
          </svg>
        </div>
      );
    case `SYSTEM_UPDATE_ALT`:
      return (
        <div {...props}>
          <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 24 24" width="24">
            <path d="M0 .5h24v24H0z" fill="none" />
            <path d="M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z" />
          </svg>
        </div>
      );
    case `DOUBLE_ARROW`:
      return (
        <div {...props}>
          <svg xmlns="http://www.w3.org/2000/svg" enableBackground="new 0 0 24 24" viewBox="0 0 24 24" fill="white" width="18px" height="18px">
            <g>
              <rect fill="none" height="24" width="24" />
            </g>
            <g>
              <g>
                <polygon points="15.5,5 11,5 16,12 11,19 15.5,19 20.5,12" />
                <polygon points="8.5,5 4,5 9,12 4,19 8.5,19 13.5,12" />
              </g>
            </g>
          </svg>
        </div>
      );
    case `TRUCK`:
      return (
        <div {...props}>
          <svg
            viewBox="0 -64 480.00378 480"
            xmlns="http://www.w3.org/2000/svg"
            fill={props.color || `black`}
            width={props.size ? `${props.size}px` : `24px`}
            height={props.size ? `${props.size}px` : `24px`}
          >
            <path d="m32.003906 89.53125 16 18.601562 24 28.101563 16 18.699219 25.800782 30.199218c4.5 5.300782 9.800781 9.699219 15.800781 13.101563l41.097656 23.699219c12.300781 7.199218 26.300781 10.898437 40.601563 11 2.597656 0 5.300781-.199219 7.898437-.402344l44.800781-4.398438h.300782c2.597656-.199218 4.898437-1.699218 6.199218-3.898437l9.5-16.5 24-41.601563 14.5-25.101562c.199219-.296875.300782-.699219.398438-1 .902344-2 .902344-4.296875 0-6.199219l-18.796875-41.300781c-7-15.398438-18.703125-28.296875-33.402344-36.699219l-41.097656-23.898437c-6-3.402344-12.402344-5.800782-19.203125-7.101563l-133-24.699219c-3.296875-.601562-6.699219.898438-8.398438 3.800782l-40 69.300781c-1.699218 2.898437-1.300781 6.597656.898438 9.199219zm0 0" />
            <path d="m471.902344 223.734375-61.296875-62.601563c-6-5.601562-13.703125-8.800781-21.800781-9.199218h-44.800782c-4.398437 0-8 3.597656-8 8v88h-16v-77.601563l-35.699218 61.902344c-3.902344 6.699219-10.800782 11.199219-18.5 11.796875l-1 .101562-.800782.101563v3.699219h-38.300781s-23.199219.597656-27.597656 0h-110.101563v-68.402344l-52.199218-61-3.800782-4.5v133.902344h-8c-3.398437 0-6.5 2.199218-7.601562 5.398437l-14.199219 42.601563-1.800781 5.398437c-.796875 2.402344-.39843775 5.101563 1.101562 7.199219 1.5 2.101562 3.898438 3.402344 6.5 3.402344h32c0 22.097656 17.898438 40 40 40 22.101563 0 40-17.902344 40-40h16c0 22.097656 17.898438 40 40 40 22.101563 0 40-17.902344 40-40h144c0 22.097656 17.898438 40 40 40 22.101563 0 40-17.902344 40-40h16c10.601563 1.199218 20.5-5.699219 23.101563-16 .597656-2.601563.898437-5.300782.898437-8v-44.199219c0-7.402344-2.898437-14.601563-8.101562-20zm-391.898438 112.199219c-13.300781 0-24-10.699219-24-24 0-13.300782 10.699219-24 24-24 13.300782 0 24 10.699218 24 24 0 13.300781-10.699218 24-24 24zm96 0c-13.300781 0-24-10.699219-24-24 0-13.300782 10.699219-24 24-24 13.300782 0 24 10.699218 24 24 0 13.300781-10.699218 24-24 24zm224 0c-13.300781 0-24-10.699219-24-24 0-13.300782 10.699219-24 24-24 13.300782 0 24 10.699218 24 24 0 13.300781-10.699218 24-24 24zm-4.699218-112c-6.199219 0-11.300782-5.101563-11.300782-11.300782v-44.699218h4.800782c3.800781.398437 7.5 1.898437 10.398437 4.398437l50.5 51.601563zm0 0" />
          </svg>
        </div>
      );
    default:
      return null;
  }
};

export default Icons;
